module.exports = __webpack_public_path__ + "static/media/vip-message-background.49c1868f.png";